import { Navigate } from 'react-router';
import authenticationHelperService from '../services/auth-helper.service';
import React from 'react';
import { Outlet } from 'react-router-dom';
import routeService from './route.service';

export default function PrivateRoute() {
  const isAuthenticated = authenticationHelperService.isAuthenticated();

  return isAuthenticated ? <Outlet /> : <Navigate to={routeService.getLoginPath()} />;
}
